<template>
  <div>
    <div class="d-sm-flex align-items-center justify-content-between mb-4" id="button_user">
      <h1 class="h3 mb-0 text-gray-800 d-inline-block">Setting Point</h1>
    </div>
    <ul class="nav nav-tabs" id="user_tab" role="tablist">
      <li class="nav-item" v-for="(data,index) in arr" :key="index">
        <a :href="'#'+data.replace(/ /g,'_')" class="nav-link" :class="{'active': index == 0}" :id="data+'-tab'" data-toggle="tab" role="tab" :aria-controls="data" :aria-selected="index == 0 ? 'true' : 'false'">{{ data }}</a>
      </li>
    </ul>
    <div class="tab-content" id="userTabContent">
      <div class="tab-pane fade" :class="{'show active': index == 0}" :id="data.replace(/ /g,'_')" role="tabpanel" :aria-labelledby="data+'-tab'" v-for="(data,index) in arr" :key="index">
        <table-skeleton v-show="is_loading"/>
        <div class="mt-3" v-show="!is_loading">
          <custom-table :arr="data_helper.arr" :total_page="data_helper.total_page" url_detail="/setting/point/action" :arr_header="data_helper.arr_header" :arr_id="data_helper.arr_id" v-if="index == 0" @on_refresh_start="on_refresh_start" @on_refresh_end="on_refresh_end"/>
          <custom-table :arr="data_majikan.arr" :total_page="data_majikan.total_page" url_detail="/setting/point/action" :arr_header="data_majikan.arr_header" :arr_id="data_majikan.arr_id" v-if="index == 1" @on_refresh_start="on_refresh_start" @on_refresh_end="on_refresh_end"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import custom_table from '@/layout/table'
import table_skeleton from '@/layout/table_skeleton'

export default {
  components:{
    'custom-table': custom_table,
    'table-skeleton': table_skeleton,
  },
  data(){
    return{
      arr:[
        'Helper',
        'Majikan',
      ],
      data_helper: {
        arr:[
          {
            pekerjaan: 'Asisten rumah tangga',
            'tanggal mulai': moment().format('DD MMM YYYY'),
            status: 'wait',
          }
        ],
        arr_header: ['pekerjaan','tanggal mulai','status'],
        total_page: 1,
      },
      data_majikan: {
        arr:[
          {
            pekerjaan: 'Asisten rumah tangga',
            'tanggal mulai': moment().format('DD MMM YYYY'),
            status: 'wait',
          }
        ],
        arr_header: ['pekerjaan','tanggal mulai','status'],
        total_page: 1,
      },
      is_loading: true,
    }
  },
  async created(){
    await this.get_helper()
    await this.get_majikan()
    this.is_loading = false
  },
  methods:{
    on_refresh_start(){
      this.is_loading = true
    },
    on_refresh_end(){
      this.is_loading = false
    },
    async get_helper(){
      try{
        var response = await axios.get(base_url+'/setting-point?api_type=web-admin&user_type=helper')

        var response_data = response.data
        if(response_data.status == "success"){
          this.data_helper.arr = response_data.arr
          this.data_helper.arr_header = response_data.arr_header
          this.data_helper.arr_id = response_data.arr_id
          this.data_helper.total_page = response_data.total_page
        }
        else
          this.$toasted.show(response_data.message)
      } catch(e){
        this.$toasted.show(e)
      }
    },
    async get_majikan(){
      try{
        var response = await axios.get(base_url+'/setting-point?api_type=web-admin&user_type=majikan')

        var response_data = response.data
        if(response_data.status == "success"){
          this.data_majikan.arr = response_data.arr
          this.data_majikan.arr_header = response_data.arr_header
          this.data_majikan.arr_id = response_data.arr_id
          this.data_majikan.total_page = response_data.total_page
        }
        else
          this.$toasted.show(response_data.message)
      } catch(e){
        this.$toasted.show(e)
      }
    },
  }
}
</script>
